var InvitedList = [
  {
    id: 0,
    name: 'Mark Riedl',
    image: 'mark_riedl_small',
    affiliation: 'Georgia Tech',
    link: 'https://www.cc.gatech.edu/people/mark-riedl',
  },
  {
    id: 1,
    name: 'Bertram Malle',
    image: 'bertrammalle',
    affiliation: 'Brown University',
    link: 'https://research.clps.brown.edu/SocCogSci/Personnel/BFM.html',
  },
  {
    id: 2,
    name: 'Francesca Toni',
    image: 'francescatoni',
    affiliation: 'Imperial College London',
    link: 'https://www.imperial.ac.uk/people/f.toni',
  },
];

var PanelList = [
  {
    id: 0,
    name: 'Mark Riedl',
    image: 'mark_riedl_small',
    affiliation: 'Georgia Tech',
    link: 'https://www.cc.gatech.edu/people/mark-riedl',
  },
  {
    id: 1,
    name: 'Bertram Malle',
    image: 'bertrammalle',
    affiliation: 'Brown University',
    link: 'https://research.clps.brown.edu/SocCogSci/Personnel/BFM.html',
  },
  {
    id: 2,
    name: 'Francesca Toni',
    image: 'francescatoni',
    affiliation: 'Imperial College London',
    link: 'https://www.imperial.ac.uk/people/f.toni',
  },
    {
    id: 3,
    name: 'Tathagata Chakraborti',
    image: 'tathagata',
    affiliation: 'IBM',
    link: 'http://tchakra2.com/',
  },
];

var MemberListCache = [
  {
    id: 1,
    name: 'Alan Lindsay',
    image: 'alanL',
    affiliation: 'Heriot-Watt University',
    link: 'https://scholar.google.co.uk/citations?user=FA9LGEwAAAAJ&hl=en',
  },
  {
    id: 15,
    name: 'Stylianos Vasileiou',
    image: 'stylianos',
    affiliation: 'Washington University',
    link: 'https://thestlucas.com/',
  },
  {
    id: 18,
    name: 'Benjamin Krarup',
    image: 'ben',
    affiliation: 'Kings College London',
    link: 'https://uk.linkedin.com/in/benjamin-krarup',
  },
  {
    id: 14,
    name: 'Rebecca Eifler',
    image: 'rebecca',
    affiliation: 'Saarland University',
    link: 'http://fai.cs.uni-saarland.de/eifler/',
  },
  {
    id: 6,
    name: 'Silvia Tulli',
    image: 'silvia',
    affiliation: 'Sorbonne University',
    link: 'https://silviatulli.com/',
  },
  {
    id: 7,
    name: 'Sarath Sreedharan',
    image: 'sarath',
    affiliation: 'Arizona State University',
    link: 'http://www.public.asu.edu/~ssreedh3/',
  },
];

var PCListCache = [
  {
    id: 1,
    name: 'Ashwin Kumar',
    affiliation: 'Washington University in St. Louis',
  },
  {
    id: 2,
    name: 'Sandhya Saisubramanian',
    affiliation: 'Oregon State University',
  },
  {
    id: 3,
    name: 'Ofra Amir',
    affiliation: 'Technion',
  },
  {
    id: 4,
    name: 'Rashmeet Kaur Nayyar',
    affiliation: 'Arizona State University',
  },
  {
    id: 5,
    name: 'Maayan Shvo',
    affiliation: 'University of Toronto',
  },
  {
    id: 6,
    name: 'Felix Lindner',
    affiliation: 'Ulm University',
  },
  {
    id: 7,
    name: 'Mudit Verma',
    affiliation: 'Arizona State University',
  },
  {
    id: 8,
    name: 'Gerard Canal',
    affiliation: "King's College London",
  },
  {
    id: 9,
    name: 'Aaquib Tabrez',
    affiliation: 'University of Colorado',
  },
  {
    id: 10,
    name: 'Fabio Mercorio',
    affiliation: 'University of Milano-Bicocca',
  },
  {
    id: 11,
    name: 'Zahra Zahedi',
    affiliation: 'Arizona State University',
  },
  {
    id: 12,
    name: 'Raymond Sheh',
    affiliation: 'Georgetown University',
  },
  {
    id: 13,
    name: 'Senka Krivic',
    affiliation: 'Kings College London, University of London',
  },
  {
    id: 14,
    name: 'Maurício Cecílio Magnaguagno',
    affiliation: 'Pontifical Catholic University of Rio Grande do Sul',
  },
  {
    id: 15,
    name: 'Pascal Bercher',
    affiliation: 'Australian National University',
  },
  {
    id: 16,
    name: 'Ashwin Kumar',
    affiliation: 'Washington University in St. Louis',
  },
  {
    id: 17,
    name: 'Pulkit Verma',
    affiliation: 'Arizona State University',
  },
  {
    id: 18,
    name: 'Giovanni Ciatto',
    affiliation: 'University of Bologna',
  },
  {
    id: 19,
    name: 'Ramon Fraga Pereira',
    affiliation: 'Sapienza University of Rome',
  },
  {
    id: 20,
    name: 'Songtuan Lin',
    affiliation: 'Australian National University',
  },
  {
    id: 21,
    name: 'Sriram Gopalakrishnan',
    affiliation: 'Arizona State University',
  },
  {
    id: 22,
    name: 'Giovanni Ciatto',
    affiliation: 'University of Bologna',
  },
  {
    id: 23,
    name: 'Sachin Grover',
    affiliation: 'Arizona State University',
  },
  {
    id: 24,
    name: 'Maayan Shvo',
    affiliation: 'University of Toronto',
  },
  {
    id: 25,
    name: 'Martim Brandão',
    affiliation: "King's College London",
  },
];

export { MemberListCache, PCListCache, InvitedList, PanelList };
